import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  menus: {
    "& > *": {
      marginBottom: 16,
    },
  },
});

function App() {
  const { menus } = useStyles();
  const theme = useTheme();
  return (
    <>
      <Box bgcolor={theme.palette.primary.main} p={2}>
        <img src="/home/images/logo.png" />
      </Box>
      <Container maxWidth="md">
        <Box
          mt={6}
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box p={4} border="1px solid #ccc" borderRadius={6}>
            <Box mt={2} mb={4}>
              <Typography variant="h5">
                Please select the program you are interested
              </Typography>
            </Box>
            <div className={menus}>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                onClick={() => (window.location.href = "/inbound")}
              >
                Inbound Program
              </Button>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                onClick={() => (window.location.href = "/cotutelle")}
              >
                Cotutelle Program
              </Button>
              <Button
                color="primary"
                variant="contained"
                fullWidth
                onClick={() => (window.location.href = "/outbound")}
              >
                Outbound Program
              </Button>
            </div>
          </Box>
        </Box>
      </Container>
    </>
  );
}

export default App;
